import { ProductSearchPage } from './ProductSearchPage/ProductSearchPage'
import './ProductSearchPage/ProductSearchPage.scss'
export default ProductSearchPage
